export default __webpack_public_path__ + "static/vehicle_warranty_4-343c06163176797b5c4d660d243493cf.webp";